/**
 * This file is used for setting up and connecting to Prismic.
 */

module.exports = {
  // The domain name of your Prismic repository. This can be found in the URL of
  // your repository.
  //
  // Example: 'my-repo' if your Prismic repository URL is 'my-repo.prismic.io'.
  prismicRepo: "grub24",

  // The default language for content in your Prismic repository.
  defaultLanguage: "en-gb",

  // All available languages for content in your Prismic repository.
  // en-ae (English, UAE) is ready in code; its pages go live once the locale
  // is added in Prismic and documents are published in it. The language
  // switcher only lists locales that have a published homepage.
  langs: ["en-gb", "en-ae", "ar-ae"],

  // Language prefix mapping for URL generation
  langPrefixes: {
    "en-gb": "", // English is the default, no prefix
    "en-ae": "en-ae", // English UAE pages under /en-ae (AED pricing, UAE details)
    "ar-ae": "ar-ae", // Arabic UAE pages under /ar-ae
  },

  // RTL languages
  rtlLanguages: ["ar-ae"],
}
